import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Validate driver email
 *
 * @private
 */
export const validateEmail = createAsyncThunk<
  // Return type of the payload creator
  Record<string, boolean>,
  // First argument to the payload creator
  string[],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/validateEmail', async (emails, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/generic/validateEmail', {
      category: 'rpc',
      type: 'rpc/generic/validateEmail',
      emails,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return response.result
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {validateEmail}`,
      { tags: ['rpc', 'generic'], info: emails },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Validate emails: ${emails.join(', ')}`,
      error,
    })
  }
})
